import { RankedModeTypes } from '../../../../shared/GameEnums.ts';
import { RankedDivisionTypes, RankedSubDivisionTypes } from '../../../../shared/leaderboard_data/LeaderboardEnums.ts';
import { RankedUserStateController, RankedUserStateType } from '@colonist/leaderboard-types';
import { ClientUserState } from '../ClientUserState.ts';
import { UIAjaxWrapper } from '../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../../shared/scripts/network/UIAPIEndpoints.ts';
import { UIUrlParameterNames } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { createDivIn, createImgIn, createLinkIn, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { UILeaderboardUtils } from '../ui_leaderboard/UILeaderboardUtils.ts';
import { UIProfileRankedProgressBarController } from './UIProfileRankedProgressBarController.ts';
import { clientI18n } from '../ClientI18n.ts';
import { UIImagePathController } from '../UIEnums.ts';
import { uiManagerEvents } from '../EntryShared.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { getProfilePopupElementId } from './UIViewProfilePopup.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIProfileRankedController {
    set username(username) {
        this._username = username;
    }
    static setPlayNowButtonClickHandlers() {
        const playNowButtons = document.getElementsByClassName('ranked-play-now');
        for (const playNowButton of playNowButtons){
            setElementOnClick(playNowButton, ()=>{
                uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.EnterMatchmaking, playNowButton.dataset.matchmakingType);
            }, false, true);
        }
    }
    async fetchRankedDataForSelectedSeason(selectedSeason) {
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.ranked(this._username), selectedSeason.toString());
        if (response == undefined) return;
        this.rankedData = response.json;
        for (const rankedData of this.rankedData){
            if (rankedData.currentRankedState == undefined) continue;
            rankedData.currentRankedState = RankedUserStateController.deserialize(rankedData.currentRankedState);
        }
        this.isSelectionCurrentSeason = selectedSeason == this.currentSeason;
        this.setRankedDataUI();
    }
    setRankedDataUI() {
        this.hackyLogicToHideAllCards();
        for (const profileDataRanked of this.rankedData){
            const rankedModeString = this.getRankedModeString(profileDataRanked.modeType);
            if (!rankedModeString) return;
            const cardId = getProfilePopupElementId(`ranked_mode_player_info_card_${rankedModeString}`, this.isPopup);
            const rankedModeCardDiv = document.getElementById(cardId);
            rankedModeCardDiv.hidden = false;
            this.createClickEventToRouteToLeaderboard(rankedModeCardDiv, profileDataRanked.modeType);
            UIProfileRankedController.updatePlayNowVisibility(rankedModeCardDiv, profileDataRanked.isLiveSeasonMode);
            const statsContainerId = getProfilePopupElementId(`ranked_mode_player_stats_${rankedModeString}_container`, this.isPopup);
            const statsContainerDiv = document.getElementById(statsContainerId);
            statsContainerDiv.replaceChildren();
            const progressContainerDivId = getProfilePopupElementId(`${this.progressContainerIdBase}_${rankedModeString}_container`, this.isPopup);
            const progressContainerDiv = document.getElementById(progressContainerDivId);
            progressContainerDiv.replaceChildren();
            if (profileDataRanked.currentRankedState != undefined) {
                this.displayCurrentSeasonState(profileDataRanked, progressContainerDiv);
            } else {
                this.populatePastSeasonProgress(profileDataRanked, progressContainerDiv);
            }
            this.populateBasicStats(profileDataRanked, statsContainerDiv);
            this.populateRankingStats(profileDataRanked, statsContainerDiv);
        }
    }
    hackyLogicToHideAllCards() {
        const allNamesToClear = [
            this.baseGameIdentifier,
            this.oneVersusOneIdentifier,
            this.citiesAndKnightsIdentifier,
            this.rushIdentifier
        ];
        for (const name of allNamesToClear){
            const cardId = getProfilePopupElementId(`ranked_mode_player_info_card_${name}`, this.isPopup);
            const rankedModeCardDiv = document.getElementById(cardId);
            rankedModeCardDiv.hidden = true;
        }
    }
    displayCurrentSeasonState(profileDataRanked, progressContainerDiv) {
        if (profileDataRanked.currentRankedState == undefined) return;
        switch(profileDataRanked.currentRankedState.type){
            case RankedUserStateType.RankedLocked:
                this.displayRankedLocked(profileDataRanked.currentRankedState, progressContainerDiv);
                break;
            case RankedUserStateType.Placement:
                var _ClientUserState_userState;
                this.displayRankedPlacementState(profileDataRanked.currentRankedState, progressContainerDiv);
                if (((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username) == decodeURIComponent(this._username)) this.createPlayNowLink(profileDataRanked, progressContainerDiv);
                break;
            case RankedUserStateType.Ranked:
                if (profileDataRanked.division != RankedDivisionTypes.None) this.createDivisionIcon(profileDataRanked.division, profileDataRanked.subdivision, progressContainerDiv);
                UIProfileRankedController.displayRankedProgressBar(profileDataRanked.currentRankedState, progressContainerDiv);
                break;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    displayRankedLocked(rankedLockedState, progressContainerDiv) {
        const rankedLockedDiv = createDivIn(progressContainerDiv, '');
        const statusText = rankedLockedState.getFindGamePopupStatusText();
        rankedLockedDiv.innerText = clientI18n.t(statusText.key, statusText.options);
    }
    // eslint-disable-next-line class-methods-use-this
    displayRankedPlacementState(rankedPlacementState, progressContainerDiv) {
        const placementGamesDiv = createDivIn(progressContainerDiv, '');
        const statusText = rankedPlacementState.getFindGamePopupStatusText();
        placementGamesDiv.innerText = clientI18n.t(statusText.key, statusText.options);
    }
    static displayRankedProgressBar(rankedMMRState, progressContainerDiv) {
        new UIProfileRankedProgressBarController(rankedMMRState.currentDivisionState, rankedMMRState.currentMMR, progressContainerDiv);
    }
    populatePastSeasonProgress(profileDataRanked, progressContainerDiv) {
        if (profileDataRanked.division == RankedDivisionTypes.None) {
            this.createNoGamesPlayedText(progressContainerDiv);
        } else {
            this.createDivisionIcon(profileDataRanked.division, profileDataRanked.subdivision, progressContainerDiv);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    createDivisionIcon(currentDivision, currentSubdivsion, progressContainerDiv) {
        const divisionIconContainer = createDivIn(progressContainerDiv, '');
        const divisionImage = UIImagePathController.getRankedDivisionImage(currentDivision);
        createImgIn(divisionIconContainer, divisionImage);
        const subdivisionImagePath = UIImagePathController.getRankedSubdivisionImage(currentSubdivsion);
        if (subdivisionImagePath != undefined) createImgIn(divisionIconContainer, subdivisionImagePath);
        const divisionName = createDivIn(progressContainerDiv, '');
        const subdivisionName = currentSubdivsion == RankedSubDivisionTypes.None ? '' : RankedSubDivisionTypes[currentSubdivsion];
        divisionName.innerText = `${RankedDivisionTypes[currentDivision]} ${subdivisionName}`;
    }
    getRankedModeString(rankedModeType) {
        switch(rankedModeType){
            case RankedModeTypes.Classic4P:
                return this.baseGameIdentifier;
            case RankedModeTypes.Classic1v1:
                return this.oneVersusOneIdentifier;
            case RankedModeTypes.CitiesAndKnights4P:
                return this.citiesAndKnightsIdentifier;
            case RankedModeTypes.Rush4P:
                return this.rushIdentifier;
            default:
                return '';
        }
    }
    populateBasicStats(profileDataRanked, statsContainerDiv) {
        const winRateText = profileDataRanked.winRate == '-' ? profileDataRanked.winRate : `${profileDataRanked.winRate}%`;
        this.createStatDiv(statsContainerDiv, {
            key: 'strings:leaderboardPage.tableHeaders.rating'
        }, profileDataRanked.skillRating);
        this.createStatDiv(statsContainerDiv, {
            key: 'strings:leaderboardPage.tableHeaders.games'
        }, profileDataRanked.gamesPlayed);
        this.createStatDiv(statsContainerDiv, {
            key: 'strings:leaderboardPage.tableHeaders.winPercentage'
        }, winRateText);
    }
    populateRankingStats(profileDataRanked, statsContainerDiv) {
        profileDataRanked.rankedStanding.forEach((rankedStanding)=>{
            this.createRankingStatsForRegionalStanding(rankedStanding, statsContainerDiv);
        });
    }
    createRankingStatsForRegionalStanding(rankedStanding, statsContainerDiv) {
        const doesRankingExist = rankedStanding.rank != '-';
        const numberSignToAdd = doesRankingExist ? '#' : '';
        const rankingWithNumberSign = numberSignToAdd + rankedStanding.rank;
        const rankStandingName = UILeaderboardUtils.tLeaderboardTabName(rankedStanding.name);
        this.createStatDiv(statsContainerDiv, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: rankStandingName
            }
        }, rankingWithNumberSign);
    }
    createStatDiv(progressContainerDiv, statName, statValue) {
        const statContainerDiv = createDivIn(progressContainerDiv, this.statContainerClass);
        const statNameDiv = createDivIn(statContainerDiv, '');
        const statValueDiv = createDivIn(statContainerDiv, 'ranked_mode_player_stat_value');
        statNameDiv.innerText = clientI18n.t(statName.key, statName.options);
        statValueDiv.innerText = statValue;
    }
    createPlayNowLink(data, progressContainerDiv) {
        const linkHref = '';
        const playNowLink = createLinkIn(progressContainerDiv, linkHref, this.playNowLinkText, '');
        setElementOnClick(playNowLink, ()=>{
            AudioManager.play(AudioType.Click);
            uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.EnterMatchmaking, data.matchmakingRedirectType);
        }, true, true);
    }
    createNoGamesPlayedText(progressContainerDiv) {
        const noGamesPlayedDiv = createDivIn(progressContainerDiv, '');
        noGamesPlayedDiv.innerText = clientI18n.t(this.noGamesPlayedText.key, this.noGamesPlayedText.options);
    }
    static updatePlayNowVisibility(cardDiv, isLiveSeasonMode) {
        const playNowButton = cardDiv.getElementsByClassName('ranked-play-now')[0];
        if (playNowButton == undefined) return;
        playNowButton.classList.toggle('hidden', !isLiveSeasonMode);
    }
    createClickEventToRouteToLeaderboard(cardDiv, mode) {
        if (!this.isSelectionCurrentSeason) {
            setElementOnClick(cardDiv, ()=>undefined);
            cardDiv.style.cursor = 'default';
            return;
        }
        cardDiv.style.cursor = 'pointer';
        setElementOnClick(cardDiv, ()=>navigateToPage(`/leaderboards/${RankedModeTypes[mode]}`));
    }
    constructor(username, isPopup = false){
        this.progressContainerIdBase = 'ranked_mode_player_progress';
        this.baseGameIdentifier = 'base';
        this.oneVersusOneIdentifier = '1v1';
        this.citiesAndKnightsIdentifier = 'citiesandknights';
        this.rushIdentifier = 'rush';
        this.statContainerClass = 'ranked_mode_player_stat';
        this.playNowLinkText = {
            key: 'strings:colonistCommon.rankedState.playNow'
        };
        this.noGamesPlayedText = {
            key: 'strings:colonistCommon.rankedState.noGamesPlayed'
        };
        this._username = username;
        this.isPopup = isPopup;
        UIProfileRankedController.setPlayNowButtonClickHandlers();
    }
}
